import { useContext } from "react";
import { ShoppingBag } from "lucide-react";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { OrderbumpsContext } from "../context/OrderbumpsContext";
import { ContainerGraphics, ContainerFilters, ContainerResumeCards, ContainerTableOrigins, ContainerTableTransactions, ContainerTableOrderbumps } from ".";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);
    const { data } = useContext(OrderbumpsContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 animate-fade-in">
                        <div className="space-y-1 mb-6">
                            <span className="label-overline">Análise</span>
                            <h1 className="display-2 flex items-center gap-3">
                                Orderbumps
                                <ShoppingBag className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Performance de upsells por produto principal — selecione um produto e período para gerar o relatório.
                            </p>
                        </div>
                        <ContainerFilters />
                    </header>

                    {data && (
                        <div className="space-y-6 animate-slide-up">
                            <ContainerResumeCards />
                            <ContainerGraphics />
                            <ContainerTableTransactions />
                            <ContainerTableOrderbumps />
                            <ContainerTableOrigins />
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}
